"use-strict";

const axios = require("axios").default;
const utilities = require("../utilities");

var _parent = {};

// axios.interceptors.request.use((request) => {
//   console.log(request)
//   return request
// });
// axios.interceptors.response.use((x) => {
//   console.log(x)
//   return x
// });

let log = false;

var google = {
  /**
   * Initializes the child module, setting up a reference to the parent SAT index
   * This allows the child module to reference all other modules without additional configuration
   *
   * @param  {object} p - The parent SAT module exported from the root index file
   */
  init: (p) => (_parent = p),

  /**
   * Returns the Axios response from a GET request to Google's API at the targeted endpoint with passed in query parameters,
   * using the API key from the parent config file
   *
   * @param {String} endpoint - The specific API endpoint to request
   * @param {String} key - The Google API key from the parent config file
   * @param {String} [params = null] - Query parameters to append onto the request URL
   * @returns {Object} The Axios response object from the GET
   */
  get: async function (endpoint, key, params = null) {
    if (!endpoint) throw "No endpoint designated";
    if (!key) throw "No Google API key found";
    log && console.log("params", params);
    let url = `https://maps.googleapis.com/maps/api/${endpoint}/json?${params ? params + "&" : ""}key=${key}`;
    log && console.log("URL", url);
    return await axios.get(url);
  },

  /**
   * Returns places data from google maps api
   * 
   * @param {String} address - A valid address string, at least the street address is required for accuracy
   * @returns {Object} - locations data returned from googlemaps places API
   * 
   */
  findPlace: async function (address) {
    const formattedAddress = this.formatAddress(address);
    const response = await _parent.google.get("place/findplacefromtext", _parent.config.google_places_key, `input=${formattedAddress}&inputtype=textquery&fields=formatted_address%2Cname`);
    const responseStatus = utilities.getPropValue(response, "data.status");
    const responseError = utilities.getPropValue(response, "data.error_message");

    if (response && response.data && responseStatus === `OK`) {
      return response.data;
    } else if (responseStatus === "ZERO_RESULTS") {
      throw new Error(`findPlace(): No results found for query${responseError ? ' - ' + responseError : ''}`);
    } else if (responseStatus === "REQUEST_DENIED") {
      throw new Error(`findPlace(): Provided Google Maps API key is invalid${responseError ? ' - ' + responseError : ''}`);
    } else if (responseStatus === "INVALID_REQUEST") {
      throw new Error(`findPlace(): Request was malformed${responseError ? ' - ' + responseError : ''}`);
    } else {
      throw new Error(`findPlace(): Request failed${responseError ? ' - ' + responseError : ''}`);
    }
  },

  /**
   * Returns places details from google maps api
   * 
   * @param {String} placeId - A valid google place ID string to search on
   * @returns {Object} - locations data returned from googlemaps places API
   * 
   */
  findPlaceDetails: async function (placeId) {
    const response = await _parent.google.get("place/details", _parent.config.google_places_key, `place_id=${placeId}&fields=utc_offset%2Cname`);
    const responseStatus = utilities.getPropValue(response, "data.status");
    const responseError = utilities.getPropValue(response, "data.error_message");

    if (response && response.data && responseStatus === `OK`) {
      return response.data;
    } else if (responseStatus === "ZERO_RESULTS") {
      throw new Error(`findPlaceDetails(): No results found for query${responseError ? ' - ' + responseError : ''}`);
    } else if (responseStatus === "REQUEST_DENIED") {
      throw new Error(`findPlaceDetails(): Provided Google Maps API key is invalid${responseError ? ' - ' + responseError : ''}`);
    } else if (responseStatus === "INVALID_REQUEST") {
      throw new Error(`findPlaceDetails(): Request was malformed${responseError ? ' - ' + responseError : ''}`);
    } else {
      throw new Error(`findPlaceDetails(): Request failed${responseError ? ' - ' + responseError : ''}`);
    }
  },

  /**
   * Returns timezone details from google maps api
   * 
   * @param {Number} latitude - The location's latitude
   * @param {Number} longitude - The location's longitude
   * @returns {Object} - locations data returned from googlemaps timezone API
   * 
   */
  findTimezoneDetails: async function (latitude, longitude) {
    const currentTimeInSec = Math.floor(Date.now() / 1000)
    const response = await _parent.google.get("timezone", _parent.config.google_timezone_key, `location=${latitude}%2C${longitude}&timestamp=${currentTimeInSec}`);
    const responseStatus = utilities.getPropValue(response, "data.status");
    const responseError = utilities.getPropValue(response, "data.error_message");

    if (response && response.data && responseStatus === `OK`) {
      return response.data;
    } else if (responseStatus === "ZERO_RESULTS") {
      throw new Error(`findTimezoneDetails(): No results found for query${responseError ? ' - ' + responseError : ''}`);
    } else if (responseStatus === "REQUEST_DENIED") {
      throw new Error(`findTimezoneDetails(): Provided Google Maps API key is invalid${responseError ? ' - ' + responseError : ''}`);
    } else if (responseStatus === "INVALID_REQUEST") {
      throw new Error(`findTimezoneDetails(): Request was malformed${responseError ? ' - ' + responseError : ''}`);
    } else {
      throw new Error(`findTimezoneDetails(): Request failed${responseError ? ' - ' + responseError : ''}`);
    }
  },

  /**
   * Returns geocoding data from google maps api
   *
   * @param {String} address - A valid street address (any format)
   * @returns {Object} - locations data returned from googlemaps geocoding API
   *
   */
  geocode: async function (address, bypassValidation = false) {
    if (!bypassValidation) {
      if (utilities.validateAddress(address) === false) {
        throw new Error(`Invalid Address: ${address}`);
      }
    }

    const formattedAddress = this.formatAddress(address);
    const response = await _parent.google.get("geocode", _parent.config.google_distance_key, `address=${formattedAddress}`);
    const responseStatus = utilities.getPropValue(response, "data.status");
    const responseError = utilities.getPropValue(response, "data.error_message");

    if (response && response.data && responseStatus === `OK`) {
      return response.data;
    } else if (responseStatus === "ZERO_RESULTS") {
      throw new Error(`geocode(): No results found for query${responseError ? ' - ' + responseError : ''}`);
    } else if (responseStatus === "REQUEST_DENIED") {
      throw new Error(`geocode(): Provided Google Maps API key is invalid${responseError ? ' - ' + responseError : ''}`);
    } else if (responseStatus === "INVALID_REQUEST") {
      throw new Error(`geocode(): Request was malformed${responseError ? ' - ' + responseError : ''}`);
    } else {
      throw new Error(`geocode(): Request failed${responseError ? ' - ' + responseError : ''}`);
    }
  },

  /**
   * Returns latitude, longitude, formatted address, and place_id
   *
   * @param  {String} address - A valid street address (any format)
   * @returns {Object} - Returns latitude, longitude, formatted address, and place_id
   *
   */
  returnLocationData: async function (address, noTimezoneCall = false) {
    try {
      // Initialize return object
      let obj = {};

      // Get geocode data
      const geocodeData = await this.geocode(address);
      const geocodeResult = geocodeData.results[0];
      
      if (geocodeResult) {
        obj = this.buildLocationObjFromGeocodeResult(geocodeResult)
      }
      else {
        throw new Error("Unexpected result handling Google geocode data");
      }
      
      // Get timezone data
      if (!noTimezoneCall) {
        const timezoneDetails = await this.findTimezoneDetails(obj.latitude, obj.longitude);
        const timezone = utilities.getPropValue(timezoneDetails, "timeZoneId");
        if (timezone) obj.timezone = timezone;
      }

      return obj;
    } catch (err) {
      console.error("SDK failed to get data from Google Maps:", err);
      return null;
    }
  },

  /**
   * Returns latitude, longitude, formatted address, and place_id
   *
   * @param  {String} geocodeResult - Google geocode response
   * @returns {Object} - Returns location object
   *
   */
  buildLocationObjFromGeocodeResult: function (geocodeResult) {
    const obj = {}
    obj.name = utilities.getPropValue(geocodeResult, "formatted_address").split(`,`)[0];
    obj.latitude = utilities.getPropValue(geocodeResult, "geometry.location.lat");
    obj.longitude = utilities.getPropValue(geocodeResult, "geometry.location.lng");
    obj.address = utilities.getPropValue(geocodeResult, "formatted_address");
    obj.place_id = utilities.getPropValue(geocodeResult, "place_id");
    //Parse address components array
    const addressComponentArray = geocodeResult.address_components || [];
    //I used a Map here because the "key" that contains the column name is nested in an array
    const addressComponentMap = new Map();
    addressComponentArray.forEach(addressComponent => {
      if (addressComponent.types && addressComponent.types.length && addressComponent.short_name) {
          addressComponentMap.set(addressComponent.types[0], addressComponent.short_name);
      }
    });
    //Address line one is a combination of two address components
    const streetNumber = addressComponentMap.get('street_number') || '';
    const streetName = addressComponentMap.get('route') || '';
    obj.address_line_one = `${streetNumber} ${streetName}` || null;
    //NOTE: this field will only store the apartment OR the PO box not both
    const apartmentOrSuite = addressComponentMap.get('subpremise') ? "Apt/Suite: " + addressComponentMap.get('subpremise') : null
    const POBox = addressComponentMap.get('post_box') ? "PO Box: " + addressComponentMap.get('post_box') : null
    obj.address_line_two = apartmentOrSuite || POBox || null;
    obj.city = addressComponentMap.get('locality');
    obj.state = addressComponentMap.get('administrative_area_level_1');
    obj.zip_code = addressComponentMap.get('postal_code');
    return obj
  },

  /**
   * Returns distance matrix data from google maps api
   *
   * @param  {String} origin - The address of the lane's origin location
   * @param  {String} destination - The address of the lane's destination location
   * @returns {Promise} - raw API data returned from googlemaps distance matrix API
   *
   */
  distance: async function (origin, destination) {
    if (utilities.validateAddress(origin) === false) {
      throw new Error(`Invalid Origin Address: ${origin}`);
    } else if (utilities.validateAddress(destination) === false) {
      throw new Error(`Invalid Destination Address: ${destination}`);
    }
    let formattedOrigin = this.formatAddress(origin);
    let formattedDestination = this.formatAddress(destination);
    let distanceData = await _parent.google.get(
      "distancematrix",
      _parent.config.google_distance_key,
      `units=imperial&origins=${formattedOrigin}&destinations=${formattedDestination}`
    );
    log && console.log("DISTANCE DATA", distanceData);
    return distanceData;
  },

  /**
   * Formats and returns the relevant 'distance data' from google maps api
   *
   * @param  {String} origin - The address of the lane's origin location *MUST BE FORMATTED CORRECTLY*
   * @param  {String} destination - The address of the lane's destination location *MUST BE FORMATTED CORRECTLY*
   * Format for addresses is <Street Number> <Street Name> <Street Type (abbr. is fine)>, <City>, <State> <Zip>, <Country>
   * @returns {Object} - values are distance in miles, average mph, and duration in seconds
   *
   */
  async returnLaneData(origin, destination) {
    let lane = null;
    let inverseLane = null;
    // Retrieve a lane object for both directions of the entered locations
    try {
      await this.distance(origin, destination)
        .then((res) => {
          lane = res.data;
        })
        .catch((error) => {
          console.error(error);
          throw error;
        });
      await this.distance(destination, origin)
        .then((res) => {
          inverseLane = res.data;
        })
        .catch((error) => {
          console.error(error);
          throw error;
        });
    } catch (err) {
      log && console.log("DistanceMatrix API call failed");
      console.error(err);
      throw err;
    }

    // Use the returned lane object that has the higher distance to ensure lanes and their inverse will be equal
    log && console.log("lane1:", lane);
    log && console.log("lane2:", inverseLane);
    let laneData = null;
    try {
      //TBI: avoid type errors
      laneData =
        lane.rows[0].elements[0].distance.value >= inverseLane.rows[0].elements[0].distance.value ? lane.rows[0].elements[0] : inverseLane.rows[0].elements[0];
    } catch (err) {
      console.error("Failed to parse the returned lane objects", err);
      throw err;
    }

    log && console.log("selected lane:", laneData);

    try {
      if (laneData.status === "OK") {
        log && console.log(`found addresses= ${laneData.origin_addresses[0]} & ${laneData.destination_addresses[0]}`);
        let meters = laneData.distance.value;
        let miles = utilities.roundToTenth(meters / 1609.344);
        let seconds = laneData.duration.value;
        let minutes = seconds / 60;
        let hours = minutes / 60;
        let mph = utilities.roundToTenth(miles / hours);
        // prevents miles from being set to 0
        if (miles === 0) {
          miles = 0.1;
        }
        const obj = {
          miles: miles,
          duration: seconds,
          avgMph: mph,
        };
        return obj;
      } else {
        let message = `Google maps API call failed due to invalid address(es).\nCheck address inputs and try again: origin = ${origin} & destination = ${destination}`;
        log && console.log(message, data);
        throw new Error(message);
      }
    } catch (err) {
      console.error("Failed to parse the longer lane object returned from distance matrix API.", err);
      throw err;
    }
  },

  /**
   * Format Address into a way that the Google API will process
   *
   * @param  {String} address - String to be formatted
   * @returns {String} - Formatted string
   *
   */
  formatAddress: function (address) {

    // Rob 2022-02-28 - Removed string replaces because its URL encoding that is needed
    // when building a string to be used in a URL query string parameters.

    //A pound sign in the address will always cause an error
    //Found this workaround here: https://support.google.com/richmedia/answer/190941?hl=en#:~:text=In%20a%20URL%2C%20a%20hash,of%20the%20page%20or%20website.
    //formattedAddress = address.replace("#", "%23").replace(" ", "");
    //NOTE: I made this a separate function in case we want to add more formatting help later

    let formattedAddress = encodeURIComponent(address);
    return formattedAddress;
  },

};

module.exports = google;
